import { z } from 'zod'

import { successResponseSchema } from '@/api/resources/shared/success'
import { arcadeInventorySchema } from '@/api/resources/shared/arcade'

const arcadeInventoryGetInputSchema = z.object({
  account: z.string()
})

export const arcadeInventoryGetResponseSchema = successResponseSchema.extend({
  data: arcadeInventorySchema
})

export type ArcadeInventoryGetInput = z.infer<
  typeof arcadeInventoryGetInputSchema
>

export type ArcadeInventoryGetResponse = z.infer<
  typeof arcadeInventoryGetResponseSchema
>
